'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/wanMTU/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "WAN MTU" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/wanMTU/StaticView#model
   * @type {actions/wanMTU/EditWanMTU}
   */

  template: twig({data: tpl}),
});
